import styled from 'styled-components'
import { theme } from '@mtsdengi/ui-kit'
import { unAuthTheme } from '@mtsdengi/common'

// убрать отключение нижнего подчеркивания после UIKIT-746

const TabletMobAccordionWrapper = styled.div`
  background-color: ${theme.colors.white};
  padding: 0 ${theme.spacings.xs}px;
  border-radius: ${unAuthTheme.radiuses.sm}px;
  margin-bottom: ${theme.spacings.md}px;

  & > :last-child > :last-child {
    display: none;
  }
`

export const Styled = {
  TabletMobAccordionWrapper,
}
